<p class="basin-mb-3 caption">
    <span>Important</span>: You must read all the terms and conditions before you can submit the form.
</p>

<div class="basin-pb-4 basin-width-100">
    <div class="terms-condition-container" (scroll)="onScroll($event)">
      <div class="terms-container">
        <p class="basin-mb-3">
          This Digital Property License Agreement (the "<strong>Agreement</strong>")
          is made by and among Stantec Consulting Ltd. or its designated Affiliate
          ("<strong>Stantec</strong>") and the party that has signified its acceptance of
          the terms and conditions of this Agreement and its Affiliates (collectively,
          "<strong>Licensee</strong>") and Licensee's Users (as defined below). Each of
          Stantec, Licensee and Licensee's Users are referred to as a "<strong>Party</strong>"
          and collectively as the "<strong>Parties</strong>".
        </p>

        <h5 class="basin-mb-2">
          WHEREAS:
        </h5>

        <ol type="A" class="basin-mb-2">
          <li class="basin-mb-3">
            Stantec has created DebrisFlow Predictor, a digital tool
            that uses data and controls to inform a numerical model that simulates complex
            behavior of debris flows ("<strong>DebrisFlow Predictor</strong>" or the "<strong>
              Digital Property
            </strong>");
          </li>

          <li class="basin-mb-3">
            Licensee wishes to subscribe for the use of the Digital
            Property by its authorized employees and/or consultants and contractors as
            provided for hereunder (collectively, "<strong>Users</strong>"); and
          </li>
          <li class="basin-mb-3">
            The Parties wish to enter into this Agreement to set out their respective rights in respect of
            Stantec's provision of, and Licensee's
            use of, the Digital Property.
          </li>
        </ol>

        <h5 class="basin-mb-2">
          NOW THEREFORE for good and valid consideration,
          the receipt and sufficiency of which is acknowledged by the Parties, the
          Parties agree as follows:
        </h5>

        <ol type="1">
          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Acceptance of Terms.</h6> Prior to accessing
            the Digital Property, Licensee and its Users will be prompted to signify their
            acceptance of these terms by clicking an "accept" button. By clicking
            the "accept" button, Licensee and its Users have indicated that they
            have read and understand this Agreement and have accepted these terms and
            conditions, including the applicable terms contained in all Schedules attached
            to this Agreement. The individual who clicks the "accept" button
            represents to Stantec that they have the full power and authority to bind
            Licensee to the terms of this Agreement. By using the Digital Property,
            Licensee and its Users accept the terms of this Agreement.
          </li>
          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Scope and Technical Parameters of Digital Property.</h6> Scope and Technical
            Parameters
            of Digital Property. Scope and Technical Parameters of Digital Property.
            Stantec shall provide Licensee with access to the Digital
            Property subject to those limitations and technical parameters as described in
            Schedule A and Licensee's compliance with the terms of this Agreement.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Training</h6>. Training sessions can be arranged
            and provided based upon the fees set out in the DebrisFlow Pricing Tool and
            shall be subject to the additional terms and conditions set out in Schedule C.
            In the event of a conflict between the terms set out in Schedule C and the
            terms of the main body of the Agreement, the terms of Schedule C shall prevail.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Definitions</h6>
            <ol type="a">
              <li class="basin-mb-3">
                "<strong>Affiliate</strong>" means, with respect to any
                Person, any other Person that directly or indirectly Controls, is Controlled
                by, or is under common Control with, such Person, whether through the ownership
                of voting securities, by contract, or otherwise.
              </li>


              <li class="basin-mb-3">
                <strong>"Background Intellectual Property"</strong>&nbsp;means
                Intellectual Property of a Party that is proprietary to that Party and was
                conceived, created, or developed prior to, or independent of, any work related
                to this Agreement.
              </li>

              <li class="basin-mb-3">
                "<strong>Control</strong>" of a Person means possessing,
                directly or indirectly (through one or more intermediaries or other means), the
                power to direct or cause the direction of management and policies of that
                Person by contract, through the ownership of voting securities (or any other
                interest) or other means.
              </li>

              <li class="basin-mb-3">
                <strong>"Diagnostic Data" </strong>means data
                created in order to monitor quality and performance of the Digital Property but
                does not include data that can be used to clearly identify an individual.
              </li>
              <li class="basin-mb-3">
                <strong>"Enhancements"</strong>&nbsp;shall mean
                changes to the Digital Property, whether made at the request of Licensee or
                implemented independently by Stantec.
              </li>
              <li class="basin-mb-3">
                <strong>"Input Data" </strong>means data compiled to
                enable the Digital Property to output information for delivery to Licensee,
                including calibration by Users.
              </li>
              <li class="basin-mb-3">
                "<strong>Intellectual Property</strong>" means all
                intellectual property, including technical information, historical research and
                analysis, documents, know-how, copyrights, models, drawings, specifications,
                prototypes, inventions, patents and software.
              </li>

              <li class="basin-mb-3">
                <strong>"Output Data" </strong>means data produced
                by the Digital Property that may include the visual representation of landslide
                paths, landslide information and metadata associated with each cell in the
                path, data shown inside the product environment, data exported for analysis
                outside the product environment (e.g. Excel, GeoTiff, Shapefiles), but
                excluding Diagnostic Data.
              </li>

              <li class="basin-mb-3">
                "<strong>Person</strong>" means any individual,
                partnership, corporation, limited liability company, trust, or other entity,
                public or private, including any government body.
              </li>
              <li class="basin-mb-3">
                <strong>"Stantec's Pre-Existing Input Data"</strong>&nbsp;means
                Input Data that is proprietary to Stantec and was conceived, created, or
                developed prior to, or independent of, any work performed pursuant to or
                related to this Agreement.
              </li>
            </ol>
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Term. </h6>The term of this Agreement shall
            commence on the Effective Date and shall continue for the period of time for
            which Licensee has subscribed for the licensing of the Digital Property.
            Sections 2, 7 to 12 and 15 to 20 shall survive termination of this Agreement.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Termination.</h6>Stantec
            or Licensee may terminate this Agreement, effective upon written notice to the
            other Parties (the "<strong>Defaulting Party</strong>"), if the Defaulting
            Party:

            <ol type="a">
              <li class="basin-mb-3">
                Materially breaches this Agreement, and such breach is
                incapable of cure, or with respect to a material breach capable of cure, the
                Defaulting Party does not cure such breach within thirty (30) days after
                receipt of written notice of such breach; or
              </li>

              <li class="basin-mb-3">
                Becomes insolvent or admits its inability to pay its
                debts generally as they become due; or
              </li>

              <li class="basin-mb-3">
                Becomes subject, voluntarily or involuntarily, to any
                proceeding under any domestic or foreign bankruptcy or insolvency law, that is
                not fully stayed within thirty (30) business days or is not dismissed or
                vacated within sixty (60) days after filing; or
              </li>

              <li class="basin-mb-3">
                Is dissolved or liquidated or takes any corporate action
                for such purpose; or
              </li>

              <li class="basin-mb-3">
                Makes a general assignment for the benefit of creditors; or
              </li>

              <li class="basin-mb-3">
                Has a receiver, trustee, custodian, or similar agent
                appointed by order of any court of competent jurisdiction to take charge of or
                sell any material portion of its property or business.
              </li>
            </ol>

            <p class="basin-mb-3">
              All confidentiality, intellectual property, ownership,
              limitation of liability, indemnity and limitation of warranty provisions
              contained in this Agreement shall survive upon the termination of this
              Agreement.
            </p>
          </li>

          <li class="basin-mb-3">
            <h5 class="basin-mb-2">Confidential Information.</h5>

            <ol type="a">
              <li class="basin-mb-3">
                The Parties may disclose confidential information to each
                other to facilitate performance of this Agreement. Such information will be
                identified as "&nbsp;<strong>Confidential Information</strong>" in writing at
                the time of its transmittal, or in the event of oral communications, when so
                identified as confidential in writing within ten (10) days thereafter and will
                be safeguarded and not disclosed to third parties by the receiving Party. Confidential
                Information will not include information that:

                <ol type="i">
                  <li class="basin-mb-3">is already known to the Party to which it is disclosed;</li>

                  <li class="basin-mb-3">
                    is or becomes part of the public domain without breach
                    of this Agreement;
                  </li>

                  <li class="basin-mb-3">
                    is obtained from third parties that, to the knowledge
                    of the receiving Party, are not subject to any obligations to the other Party
                    to keep such information confidential; or
                  </li>
                  <li class="basin-mb-3">
                    was independently developed by the receiving Party
                    without the use of any of the Confidential Information of the disclosing
                    Party.
                  </li>
                </ol>
              </li>

              <li class="basin-mb-3">
                Notwithstanding anything contained herein, each Party may
                disclose Confidential Information to its officers, employees, consultants and
                agents on a need-to-know basis as required to perform this Agreement, provided
                that such persons agree to be bound by terms at least as restrictive as those
                contained herein.
              </li>

              <li class="basin-mb-3">
                Notwithstanding any provision herein to the contrary, in
                the event that the receiving Party becomes obligated by mandatory applicable
                law, regulatory rule, public records request, subpoena or judicial or
                administrative order to disclose Confidential Information or any portion
                thereof, to any governmental authority or court, such receiving Party shall, if
                legally permitted, immediately notify the disclosing Party of each such
                requirement and identify the Confidential Information so required thereby, so
                that the disclosing Party may seek an appropriate protective order or other
                remedy with respect to narrowing the scope of such requirement and/or waive
                compliance by the receiving Party with the provisions of this Agreement. If, in
                the absence of such protective order or other remedy, the receiving Party is
                nonetheless required by mandatory applicable law to disclose any part of the
                Confidential Information that is disclosed to it hereunder to any governmental
                authority or court, such receiving Party may disclose such Confidential
                Information without liability hereunder, provided, that, the receiving Party
                shall furnish only such portion of the Confidential Information that is legally
                required to be disclosed and only to the extent required by law.
              </li>

              <li class="basin-mb-3">
                All obligations of confidence and non-use created under
                this Agreement shall terminate five (5) years from the completion or
                termination of this Agreement. Upon written request of the disclosing Party,
                the receiving Party agrees to return all copies of Confidential Information to
                the disclosing Party; provided, however, that the receiving Party shall be
                entitled to retain one (1) archival copy of all Confidential Information solely
                to ensure compliance with their rights and obligations hereunder.
              </li>
            </ol>
          </li>

          <li class="basin-mb-3">

            <h5 class="basin-mb-2">Ownership.</h5>

            <ol type="a">
              <li class="basin-mb-3">
                <h6 class="basin-mb-2">Background Intellectual Property.</h6>&nbsp;Each
                Party shall each retain all right, title and interest in its own Background
                Intellectual Property.
              </li>
              <li class="basin-mb-3">
                <h6 class="basin-mb-2">Digital Property and Enhancements. </h6>Stantec
                exclusively owns and retains all right, title and interest in the Digital
                Property, including Enhancements that result from Licensee feedback. Stantec
                provides Licensee with a limited, non-exclusive, non-transferable,
                non-sublicensable, term license to access and use the Digital Property and
                Enhancements, subject to the terms of this Agreement.
              </li>

              <li class="basin-mb-3">
                <h6 class="basin-mb-2">Input Data. </h6>

                <p class="basin-mb-3">
                  Input Data that the Licensee
                  inputs into the Digital Property shall be owned by Licensee. Licensee provides
                  Stantec with a worldwide, perpetual, irrevocable, transferable, sublicensable,
                  license to Licensee's Input Data for purposes of performing its obligations
                  under this Agreement and for the purposes of improving the quality or delivery
                  of the Digital Property, for the creation of anonymized datasets for further
                  analysis and use outside of this Agreement and for the development of new technologies
                  and processes. Stantec exclusively owns and retains all right, title and
                  interest in Stantec's Pre-Existing Input Data. Stantec provides Licensee with a
                  limited, revocable, non-exclusive, non-transferable, non-sublicensable, term
                  license to use Stantec's Pre-Existing Input Data, subject to the terms of this
                  Agreement. Licensee agrees to only use Input Data that it owns or that it has
                  license to lawfully input into the Digital Property.
                </p>


                <p class="basin-mb-3">
                  In order to effectively use the Digital Property, Licensee
                  acknowledges that it shall be required to calibrate its use of the Digital
                  Property by entering certain Licensee Input Data into the Digital Property.
                  Licensee acknowledges that Stantec will not have any obligation to review,
                  verify or confirm the accuracy of Input Data or the calibration activities
                  performed by Licensee. Licensee acknowledges that its failure to properly
                  calibrate the Digital Property could result in the creation of Output Data that
                  is inaccurate, erroneous, or incomplete. Licensee agrees that it shall be
                  solely liable for any claims, damages, losses, and/or expenses, direct and
                  indirectly incurred by Licensee through its use of or reliance upon Input Data,
                  or any third parties that are provided with Input Data, or Licensee's failure
                  to properly calibrate the Digital Property.
                </p>
              </li>

              <li class="basin-mb-3">
                <h6 class="basin-mb-2">Output Data. </h6>Licensee exclusively owns and
                retains all right, title and interest in Output Data. Licensee acknowledges
                that Stantec will not access, nor will have any obligation to review, verify or
                confirm the accuracy of Output Data. Licensee agrees that it shall be solely
                liable for any claims, damages, losses, and/or expenses, direct and indirectly
                incurred by Licensee through its use of or reliance upon Output Data, or any
                third parties that are provided with Output Data.
              </li>

              <li class="basin-mb-3">
                <h6 class="basin-mb-2">Diagnostic Data.</h6>&nbsp;Stantec exclusively
                owns and retains all right, title and interest in Diagnostic Data.
              </li>
            </ol>
          </li>

          <li class="basin-mb-3">
            <h5 class="basin-mb-2">Licensee Responsibilities.</h5>
            <ol type="a">
              <li class="basin-mb-3">
                Licensee agrees not to, directly or indirectly, and shall
                ensure its Users do not:

                <ol type="i">
                  <li class="basin-mb-3">
                    Upload or distribute in any way files that contain
                    viruses, corrupted files or any similar software or programs that may damage
                    the operation of the Digital Property;
                  </li>
                  <li class="basin-mb-3">
                    Duplicate, modify, decompile, reverse engineer, or
                    disassemble the Digital Property or create any derivative works thereof;
                  </li>

                  <li class="basin-mb-3">
                    Copy, sub-license, sell, rent, lease, distribute or
                    otherwise transfer rights or provide any party with access to the Digital
                    Property or any portion of the Digital Property. Licensee acknowledges that
                    licenses to use the Digital Property care assigned to specific Users and that
                    Users are not permitted to share their access credentials with any other
                    individual;
                  </li>

                  <li class="basin-mb-3">
                    Use or replicate the Digital Property, or allow other
                    parties to review the model or source code, use, or replicate the Digital
                    Property to compete with Stantec in any aspect of Stantec's business;
                  </li>

                  <li class="basin-mb-3">
                    Provide access to the Digital Property to any third
                    parties without the prior written consent of Stantec; or
                  </li>

                  <li class="basin-mb-3">
                    Use the Digital Property in any manner not authorized by
                    this Agreement.
                  </li>
                </ol>
              </li>

              <li class="basin-mb-3">
                The Parties will not reverse engineer, modify or create
                derivative works to avoid the terms of this Agreement.
              </li>

              <li class="basin-mb-3">
                Licensee shall ensure that all Users are legally required
                to comply with the terms of this Agreement, including the confidentiality
                provisions contained herein.
              </li>
              <li class="basin-mb-3">
                Licensee is responsible for, and shall indemnify Stantec
                for, any and all misuse, misappropriation, of the Digital Property as well as
                disclosure of Confidential Information, by Users.
              </li>
              <li class="basin-mb-3">
                Licensee is responsible for all costs incurred by Users
                in accessing the Digital Property.
              </li>
            </ol>
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">No Warranty. </h6>THE DIGITAL PROPERTY IS
            PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR
            IMPLIED, INCLUDING (WITHOUT LIMITATION) THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. STANTEC MAKES NO WARRANTY
            THAT THE DIGITAL PROPERTY WILL MEET LICENSEE'S REQUIREMENTS, THAT THE DIGITAL
            PROPERTY WILL OPERATE IN COMBINATION WITH ANY OTHER PRODUCTS, PROGRAMS OR
            SOFTWARE THAT LICENSEE MAY SELECT FOR ITS USE OR WILL BE ERROR-FREE,
            UNINTERRUPTED, TIMELY OR SECURE. LICENSEE ACKNOWLEDGES THAT PROGRAMS, SOFTWARE
            AND DIGITAL PLATFORMS IN GENERAL ARE NOT ERROR-FREE. STANTEC DOES NOT WARRANT
            OR MAKE ANY REPRESENTATIONS REGARDING THE USE, OR THE RESULTS OF USE, OF THE
            DIGITAL PROPERTY OR ITS INTERACTION WITH LICENSEE'S DATA WITH RESPECT TO THEIR
            CORRECTNESS, ACCURACY, RELIABILITY, OR OTHERWISE. STANTEC SHALL NOT BE LIABLE
            FOR ANY LOSS OR DAMAGE SUFFERED BY LICENSEE ARISING FROM ANY DEFECT IN THE
            DIGITAL PROPERTY AND LICENSEE ASSUMES ALL LIABILITY FOR USE OF THE DIGITAL
            PROPERTY AND ANY DECISIONS MADE BASED ON THE OUTPUT, INCLUDING THOSE DECISIONS
            THAT MAY CAUSE DEATH, PERSONAL INJURY, BODILY HARM OR PROPERTY DAMAGE. USE OF
            THE DIGITIAL PROPERTY DOES NOT RELIEVE LICENSEE OF THE RESPONSIBILITY TO
            EXERCISE PROFESSIONAL JUDGMENT.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Limitation of Liability. </h6>STANTEC SHALL NOT
            BE LIABLE TO LICENSEE FOR ANY LOSS OR DAMAGE WHATSOEVER OR HOWSOEVER CAUSED,
            INCLUDING, BUT NOT LIMITED TO, DEATH, PERSONAL INJURY, BODILY HARM OR PROPERTY
            DAMAGE, ARISING DIRECTLY OR INDIRECTLY IN CONNECTION WITH THIS AGREEMENT, THE
            DIGITAL PROPERTY, ITS USE, APPLICATION, SUPPORT OR OTHERWISE, EXCEPT TO THE
            EXTENT TO WHICH IT IS UNLAWFUL TO EXCLUDE SUCH LIABILITY UNDER THE APPLICABLE
            LAW. NOTWITHSTANDING THE GENERALITY OF THE ABOVE, STANTEC EXPRESSLY EXCLUDES
            LIABILITY FOR ANY INDIRECT, SPECIAL, INCIDENTAL OR CONSEQUENTIAL LOSS OR DAMAGE
            THAT MAY ARISE IN RESPECT OF THE DIGITAL PROPERTY, ITS USE OR IN RESPECT OF
            DAMAGE TO OR LOSSES RELATING TO EQUIPMENT OR PROPERTY OR FOR LOSS OF PROFIT,
            BUSINESS, REVENUE, GOODWILL OR ANTICIPATED SAVINGS. IF ANY EXCLUSION CONTAINED
            IN THIS AGREEMENT SHALL BE HELD TO BE INVALID FOR ANY REASON AND STANTEC
            BECOMES LIABLE FOR LOSS OR DAMAGE THAT MAY LAWFULLY BE LIMITED, STANTEC'S TOTAL
            LIABILITY TO LICENSEE FOR ALL CLAIMS UNDER THIS AGREEMENT SHALL BE LIMITED TO
            THE LESSER OF: (I) THE AMOUNT PAID BY LICENSEE TO STANTEC UNDER THIS AGREEMENT
            FOR THE PRECEDING TWELVE (12) MONTH PERIOD BEFORE SUCH CLAIM AROSE; OR (II)
            $10,000.00 USD.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Indemnity.</h6>
            LICENSEE RELEASES STANTEC FROM ANY LIABILITY AND AGREES TO DEFEND, INDEMNIFY
            AND HOLD STANTEC HARMLESS FROM ANY AND ALL CLAIMS, DAMAGES, LOSSES, AND/OR
            EXPENSES, DIRECT AND INDIRECT, INCLUDING BUT NOT LIMITED TO REASONABLE
            ATTORNEY'S FEES AND CHARGES AND COURT AND ARBITRATION COSTS, ARISING OUT OF, OR
            CLAIMED TO ARISE OUT OF, LICENSEE'S USE OF THE DIGITAL PROPERTY, EXCEPTING
            LIABILITY ARISING FROM STANTEC'S GROSS NEGLIGENCE OR WILLFUL MISCONDUCT.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Privacy.</h6>All personally identifiable information
            (“<strong>PII</strong>”) provided by Licensee to Stantec under this Agreement will be
            held and processed in accordance with applicable privacy laws and used in
            accordance with Stantec’s privacy notice, a copy of which was provided to
            Licensee upon registration. Further details can be found in Stantec’s Privacy
            Policy which is available on Stantec’s website. PII shall be used solely in
            connection with License’s access to the Digital Property. Stantec will
            implement and maintain appropriate technical and organizational security
            measures to protect PII against unauthorized or unlawful processing and
            accidental loss, theft, use, disclosure, destruction and/or damage.


            <p class="basin-mb-3">
              Licensee agrees that Stantec shall be permitted to transfer
              PII to its affiliates and group companies in Canada and the United States of
              America in connection with Licensee’s use of the Digital Property, provided
              that such transfers are in accordance with relevant requirements of applicable
              privacy law.
            </p>

            <p class="basin-mb-3">
              Other than the details requested as part of account creation
              and log-in, Licensee will not upload any other PII to the Digital Property.
              However, if Licensee uploads any further PII relating to Licensee or to any
              third party, Licensee warrants it has all authorizations, approvals and
              consents necessary in order to lawfully transfer the PII to Stantec, and to
              authorize Stantec to process the same in connection with providing access to
              the Digital Property.
            </p>
            <p class="basin-mb-3">
              On expiry or termination of this Agreement, Stantec may
              retain copies of PII for up to two (2) years. Thereafter, Stantec shall delete
              all PII held or processed by Stantec in connection with this Agreement and
              Licensee’s access to the Digital Property.
            </p>
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Force Majeure. </h6>Except for the payment of a
            monetary amount that is due under the terms of this Agreement, no Party shall
            be responsible for a delay in performance under this Agreement if such delay is
            caused by a force majeure event or an event beyond its reasonable control or
            contemplation, including, but not limited to, labor strikes, riots, war, acts
            of governmental authorities, inability to obtain required materials or
            services, severe weather conditions or other natural catastrophe or acts of
            God.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Assignment. </h6>Licensee shall not, without the
            prior written consent of Stantec, assign the benefit or in any way transfer the
            obligations of this Agreement or any part hereof. Stantec may assign this
            Agreement without Licensee's consent.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Entire Agreement. </h6>This Agreement constitutes the sole and entire
            agreement of the
            Parties
            with respect to the subject matter contained herein, and supersedes all prior
            and contemporaneous understandings, agreements, representations, and
            warranties, both written and oral, with respect to such subject matter. Any
            other agreements to which the Parties are currently bound, including any
            agreements for the performance of services by Stantec for Licensee, shall be of
            no force and effect with respect to the subject matter of this Agreement.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Amendment and Waiver.</h6> This Agreement may be
            amended or modified only by a written document executed by each of the Parties.
            A Party may in writing waive any provisions of this Agreement to the extent
            such provision is for the benefit of the waiving Party.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Severability. </h6>The invalidity or
            unenforceability of any provision of this Agreement shall not affect the other
            provisions and shall be construed in all respects as if an invalid or
            unenforceable provision were omitted.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Governing Law. </h6>The validity, construction
            and performance of this Agreement shall be governed by the laws, without regard
            to the laws as to choice or conflict of laws, of the Province of Alberta.
            Licensee shall comply with all applicable laws and regulations of any country,
            province, state or government agency relating to the use, sale or export of the
            Digital Property. The validity, construction and performance of the Agreement
            and all disputes between the Parties arising out of this Agreement or as to any
            matters related to but not covered by this Agreement shall be governed by the
            laws, without regard to the laws as to choice or conflict of laws, of the
            Province of Alberta.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Independent Parties.</h6> Nothing in this
            Agreement is intended or shall be construed to establish or create an agency,
            partnership or joint venture relationship between the Parties.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">No Third-Party Beneficiaries.</h6>
            This Agreement is intended for the sole benefit of
            the signatories to this Agreement and is binding on their respective successors
            and permitted assigns. Nothing in this Agreement is intended or may be
            construed to give any person, firm, corporation or other entity, other than the
            signatories hereto any legal or equitable right, remedy or claim under this
            Agreement.
          </li>
        </ol>

        <h5 class="basin-mb-2">SCHEDULE A</h5>

        <h6 class="basin-mb-2">DISCLAIMERS AND LIMITATIONS</h6>

        <p class="basin-mb-3">
          DebrisFlow Predictor is landslide runout software that is
          predicated on the idea that shallow landslides of the flow-type (debris flows
          and debris avalanches) exhibit similar aggregate behavior, based largely on
          slope, independent of geology, triggering event, rheology, or other secondary
          and tertiary order effects. Calibration for local differences can be done
          experimentally by running DebrisFlow Predictor and comparing results to
          existing landslides.
        </p>

        <h5 class="basin-mb-2">Model Disclaimers and Limitations</h5>

        <p class="basin-mb-3">
          DebrisFlow Predictor incorporates peer-reviewed techniques
          to predict dynamic behavior in the physical world. Representation of that
          behavior assumes complete and accurate information about the environments for
          which the models are developed. There are practical limitations to meeting this
          standard, and the User must note that those limitations can affect the results.
        </p>

        <p class="basin-mb-3">
          There may be elements that are not known or not available to
          Stantec that can affect predictions including local physical conditions that
          are not resolvable at the model scale, or inputs and interactions that arise
          dynamically through behavior that are not included in model dynamics. Stantec
          does its best to mitigate or address these limitations and uncertainties by
          obtaining representative environmental data, where agreed under the scope of
          work, using mapping techniques, field programs, intrusive investigations,
          referencing published literature, and reviewing previous studies. In this
          manner, Stantec includes available and accepted environmental models to reduce
          epistemic uncertainty.
        </p>

        <p class="basin-mb-3">
          Using DebrisFlow Predictor, the user can run multiple
          predictive simulations to identify credible outcomes. These probabilistic
          models do not mean that any particular outcome will occur in any real-world
          event, nor do they mean that unpredicted outcomes will not occur.
          Interpretation of these predictions require an understanding of these
          uncertainties, high level of subject matter expertise, and good professional
          judgment. Assumptions that apply specifically to the use of DebrisFlow
          Predictor.
        </p>
        <ul>
          <li class="basin-mb-3">
            Local topography smaller than the digital elevation model
            (DEM) resolution or not captured by the DEM (due to DEM quality or the
            difference between ground conditions when the DEM was captured and existing
            ground conditions) may affect the path selection or landslide behavior in a
            manner not resolvable by DebrisFlow Predictor.
          </li>

          <li class="basin-mb-3">
            Landslide behavior including inundation, runout, scour,
            deposition, spread, and path selection, may vary from modeled behavior for
            several reasons including differences in user-defined initiation zones from
            natural initiation zones, stochastic variability in the landsliding process
            (natural or modeled), controlling factors that defy parameterization within the
            model, and generalizations used to make the model practical and applicable
            across large areas.
          </li>
          <li class="basin-mb-3">
            DebrisFlow Predictor does not model debris floods and may
            underestimate runout of channelized debris flows that are transitional to
            debris floods. However, DebrisFlow Predictor will show which channels are
            likely to be charged with sediment that may in turn be susceptible to debris
            floods. Nonetheless, the distinction should be recognized by the reader.
          </li>
          <li class="basin-mb-3">
            DebrisFlow Predictor simplifies extremely complex behavior
            to provide reasonable predictions of outcomes. Should there be a perceived
            difference between modeled results, and on-the-ground evidence, the
            ground-based evidence should take priority. DebrisFlow Predictor does not
            relieve professionals from using their experience, training, and education to
            make good judgments when assessing actual ground conditions, but provides
            additional understanding of processes, and credible outcomes.
          </li>
        </ul>

        <h5 class="basin-mb-2">SCHEDULE B</h5>

        <h6 class="basin-mb-2">FEES</h6>

        <ol type="1">
          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Fees.</h6> In exchange for Licensee's license to
            access the Digital Property, Licensee shall pay Stantec fees as set out in the
            DebrisFlow Predictor Pricing Tool based on Licensee's selections. Licensee
            shall have no right to access the Digital Property until Stantec has received
            payment in accordance with this Agreement. All payments made under this
            Agreement shall be made in US dollars.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Payment Terms.</h6> Licensee's failure to make any
            payment as required under this Agreement is a material breach of this Agreement
            and will entitle Stantec, at its option, to suspend or terminate this Agreement
            and to remove Licensee's access to the Digital Property. Interest will accrue
            on accounts overdue by thirty (30) days at the lesser of 1.5 percent per month
            (18 percent per annum) or the maximum legal rate of interest.
          </li>

          <li class="basin-mb-3">
            <h6 class="basin-mb-2">Taxes.</h6> Licensee agrees to pay any applicable
            taxes, assessments and duties including, but not limited to, all national,
            foreign, state, local, regional, provincial or municipal sales and/or use
            taxes, value added taxes, goods and services taxes, consumption taxes, personal
            property taxes, ad valorem taxes, custom duties, import fees, stamp duty,
            intangibles tax, registration fees or other fee or charge of any kind or nature
            that is levied or imposed by any governmental authority on Licensee's use or
            license of the Digital Property. If Licensee is exempt from value-added or
            sales tax, uses the Digital Property in an exempt manner, or otherwise deems
            itself not subject to value-added or sales tax, then Licensee must provide a
            valid and executed exemption certificate, direct pay permit, or other such
            government approved documentation in good faith to Stantec. If Licensee is
            required by law to make any income tax deduction or to withhold income tax from
            any sum payable directly to Stantec hereunder, Licensee shall promptly effect
            payment thereof to the applicable tax authorities, and shall also promptly
            provide Stantec with official tax receipts or other evidence issued by the
            applicable tax authorities sufficient to establish that the income taxes have
            been paid and to enable Stantec to support a claim for tax credit relief for
            such income tax payments made on its behalf by Licensee.
          </li>
        </ol>

        <h5 class="basin-mb-2">SCHEDULE C</h5>

        <h6 class="basin-mb-2">TRAINING CONTENT AND SUPPORT TERMS AND CONDITIONS</h6>

        <p class="basin-mb-3">
          All use and access of DebrisFlow Predictor training
          materials ("<strong>Content</strong>") and optional support ("<strong>Support</strong>")
          that you may access or subscribe for are subject to the terms and conditions
          outlined in this Schedule C.
        </p>

        <h5 class="basin-mb-2">License</h5>

        <p class="basin-mb-3">
          Subject to these terms and conditions, Stantec grants you a
          non-exclusive, non-transferable, personal right to access, use and view Content
          and access Support. Licensee and its Users may display, download and print out
          Content for their own personal use only. Licensee and its Users may not, nor
          may allow others to, directly or indirectly copy, transfer, lend, sell, or
          modify any Content or Support or remove any proprietary notices contained
          therein, or create derivative works based on Content or Support.
        </p>

        <h5 class="basin-mb-2">Restriction on Sharing</h5>

        <p class="basin-mb-3">
          Licensee and its Users may not disseminate any portion of
          the Content or Support through electronic or other means, including without
          limitation mail lists or electronic bulletin boards and agrees not to restrict
          or inhibit any other User's access to, or use of, the Content or Support.
          Licensee and its Users may not use Content or Support in any way that is
          unlawful, offensive, upsetting, intended to disgust, threatening, libelous,
          defamatory, obscene or otherwise objectionable. Stantec reserves the right, but
          not the obligation, to, in its sole discretion, determine whether the use of
          Content or Support is appropriate and complies with these terms and conditions.
        </p>

        <h5 class="basin-mb-2">No Warranty</h5>

        <p class="basin-mb-3">
          Content and Support do not constitute professional advice or
          an endorsement, sponsorship or recommendation by Stantec of Licensee's or its
          Users' use of the Digital Property. Licensee's and Users' use of Content and
          Support is at their own risk. Content and Support, and all materials associated
          therewith, are provided on an "as is" basis. Stantec does not make
          any guarantees or warranties of any kind, either express or implied, including,
          but not limited to implied warranties of merchantability or fitness for a
          particular purpose or as to the accuracy, completeness, currency, or results to
          be obtained from accessing and using Content or Support.
        </p>

        <h5 class="basin-mb-2">Limitations of Liability</h5>

        <p class="basin-mb-3">
          In no event shall Stantec or any of its affiliates or any of
          their present and future officers, directors, employees, owners, agents,
          contractors and representatives and each of their heirs, administrators,
          successors and assigns (collectively, "<strong>Releasees</strong>") be liable
          to Licensee or its Users in respect of their use of or access to Content or
          Support. The Releasees or any one of them are not liable for any direct,
          indirect, punitive, special, or consequential damages arising out of Licensee's
          or its Users' use of or access to Content or Support, whether based upon loss
          of profits, lost time or lost money, or otherwise, whether or not such loss or
          damage is based on contract, warranty, negligence, indemnity or otherwise.
        </p>

        <p class="basin-mb-3">
          If, notwithstanding the foregoing, damages are awarded
          against Releasees or any one of them, Licensee agrees that all damages of
          whatever kind shall not exceed $4,000.00. As some jurisdictions do not allow
          the exclusion or limitation of incidental or consequential damages, Stantec's
          liability in such jurisdictions shall be limited to the maximum extent
          permitted by law.
        </p>

        <h5 class="basin-mb-2">Indemnity</h5>

        <p class="basin-mb-3">
          You agree to defend, indemnify and hold harmless the
          Releasees and each of them from and against any and all claims, actions,
          liabilities or demands, including, without limitation, reasonable legal fees,
          arising out of, related to, or based upon your participation in any course,
          Licensee's or its Users' use of Content and Support.
        </p>
        <p><strong>Read our <a href="https://www.stantec.com/en/copyright" target="_blank"><u>privacy statement</u></a> for more information on how your data is handled. </strong> </p>

      </div>
    </div>
</div>

<div class="basin-display-flex basin-justify-content-end basin-width-100">
    <button pButton type="submit" (click)="onAcceptTermsCondition()" [disabled]="!isScrolledToBottom"
        class="p-button-primary">
        I agree
    </button>
</div>
